import { render, staticRenderFns } from "./CardTopRanking.vue?vue&type=template&id=30c39fcd&scoped=true"
import script from "./CardTopRanking.vue?vue&type=script&lang=js"
export * from "./CardTopRanking.vue?vue&type=script&lang=js"
import style0 from "./CardTopRanking.vue?vue&type=style&index=0&id=30c39fcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c39fcd",
  null
  
)

export default component.exports